import ClockSvg from '@assets/images/svg/clock.svg';
import React from 'react';
import { View } from 'react-native';

export interface ClockIconProps {
    size?: number;
    color?: string;
}

export const ClockIcon = React.memo<ClockIconProps>(function ClockIcon({
    size = 18,
    color = '#FFD702',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ClockSvg width={size} height={size} color={color} />
        </View>
    );
});

export default ClockIcon;
